export const GetIdFromToken = () => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
        return null;
    }
    return decodeToken(token).nameid;
}

export const GetRoleFromToken = () => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
        return null;
    }
    return decodeToken(token).role;
}

export const GetSystemsFromToken = () => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
        return null;
    }
    const systems = decodeToken(token).SystemsAvailable;
    const systemsArray = systems.replace(/\s/g, '').split(',');
    const systemsObject = convertArrayToObject(systemsArray);
    return systemsObject;
}

export const GetMenuIdsFromToken = (): number[] => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
        return [];
    }
    const menuIds = decodeToken(token).MenuIds;
    if (!menuIds || typeof menuIds !== 'string') {
        return [];
    }
    return menuIds.split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n));
}

export const GetUserNameFromToken = () => {
    const token = localStorage.getItem('auth_token');

    if (!token) {
        return null;
    }
    return decodeToken(token).unique_name;
}


const decodeToken = (token: string): any => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
}

const convertArrayToObject = (array: string[]): Record<string, string> => {
    const systemNames: Record<string, string> = {
        "1": "Carvest",
        "2": "123 Lease",
        "3": "SKLeasing",
        "4": "Crédito Real",
        "5": "Grupo Automundo",
        "6": "GPS Auto SEV",
        "7": "Mexleasing",
        "8": "APM",
        "9": "ArrendaClick",
        "10":"Nitro"
    };

    return Object.fromEntries(
        array.map(id => [id, systemNames[id] || "Sistema Desconocido"])
    );
}

export const removeToken = () => {
    localStorage.removeItem('auth_token');
}

export const removeUserSelection = () => {
    localStorage.removeItem('auth_user');
}

export const removeRefreshToken = () => {
    localStorage.removeItem('auth_refresh_token');
}
